import styled from 'styled-components';

export const StyledActionsMenuWrapper = styled.div`
    position: absolute;
    top: 0px;
    right: 0px;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    z-index: 999;
    background: #ffffff70;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    button {
        box-shadow: rgb(50 50 50 / 30%) 0px 5px 10px;
        margin-right: 10px;
    }
`;
